<template>
	<div class="brackets__statuses-map">
		<span class="opened">{{$t('Opened')}}</span>
		<span class="started">{{$t('Started')}}</span>
		<span class="checkin">{{$t('Checkin')}}</span>
		<span class="collecting">{{$t('Collecting')}}</span>
		<span class="finished">{{$t('Finished')}}</span>
		<span class="pending">{{$t('Pending')}}</span>
		<span class="conflict">{{$t('Conflict')}}</span>
	</div>
</template>

<script>
	export default {
		name: "BracketsStatusesMap",
	};
</script>
